import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[searchSlash]' })
export class SearchSlashDirective {
  @Input() set searchSlash(value: string) {
    this.el.nativeElement.value = this.returnSlash(value);
  }

  constructor(private el: ElementRef) {}

  private returnSlash(value: string): string {
    if (value.includes(`%2F`) || value.includes(`%5C`)) {
      const forwardSlash = new RegExp('%2F', 'g');
      const backwardSlash = new RegExp('%5C', 'g');

      return value.replace(forwardSlash, '/').replace(backwardSlash, '\\');
    } else {
      return value;
    }
  }
}
